export const navbarTexts = {
  et: {
    available: "Rendipillid",
    contracts: "Lepingud",
    invoices: "Arved",
    profile: "Profiil",
    logout: "Logi välja",
    login: "Logi sisse",
    register: "Registreeru",
    faq: "Infoleht/KKK",
  },
  en: {
    available: "Available Instruments",
    contracts: "Contracts",
    invoices: "Invoices",
    profile: "Profile",
    logout: "Logout",
    login: "Login",
    register: "Register",
    faq: "FAQ",
  },
};